(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //
  const PRODUCTS = {
    PRINTIX: { id: 'PRINTIX', name: 'Printix' },
    POWER_PDF: { id: 'POWER_PDF', name: 'Power PDF' }
  };

  const PRIORITIES = {
    DEFAULT: { id: 'NORMAL', name: '-' },
    LOW: { id: 'LOW', name: 'Low' },
    NORMAL: { id: 'NORMAL', name: 'Normal' },
    HIGH: { id: 'HIGH', name: 'High' },
    URGENT: { id: 'URGENT', name: 'Urgent' }
  };

  const CONFIG = {
    PRIORITIES: [
      PRIORITIES.DEFAULT,
      PRIORITIES.LOW,
      PRIORITIES.NORMAL,
      PRIORITIES.HIGH,
      PRIORITIES.URGENT
    ],
    PRODUCTS: [
      PRODUCTS.PRINTIX,
      PRODUCTS.POWER_PDF
    ],
    DEFAULT_PRIORITY: PRIORITIES.DEFAULT.id
  };

  function getItemById(list, id) {
    return list.find(item => item.id === id) ?? list[0];
  }

  function detectTenantProduct(tenant) {
    if (tenant) {
      if (tenant.isPowerPDFOnly()) {
        return { product: PRODUCTS.POWER_PDF, isSingle: true };
      }
      if (tenant.isPrintixOnly()) {
        return { product: PRODUCTS.PRINTIX, isSingle: true };
      }
    }
    //Both PRINTIX and POWER_PDF > Default to PRINTIX
    return { product: PRODUCTS.PRINTIX, isSingle: false };
  }

  function extractId(value) {
    return (value && typeof value === 'object' && value.id) ? value.id : value;
  }

  function pxErrorDirective(
    $timeout, $filter, toastr, $http, $window, $rootScope, APIAdmin
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        meta: '=meta',
        me: '=me',
        error: '=error',
        callback: '&callback'
      },
      templateUrl: 'app/directives/error-directive/error.template.html',
      link: function (scope) {

        var productInfo = detectTenantProduct(scope.tenant);

        scope.date = scope.error.headers ? scope.error.headers()['date'] : new Date();
        scope.thresholdToSwitchCreatedTimeFormat = 6;

        scope.messageExpand = false;
        scope.detailsExpand = false;
        scope.supportExpand = false;

        scope.supportTicket = {
          email: angular.copy(scope.me.info._embedded.user.email),
          subject: scope.error.data.parameterizedErrorText,
          description: '',
          ticketPriority: CONFIG.DEFAULT_PRIORITY,
          ticketProduct: productInfo.product.id,
          phoneNumber: '',
          ticketMetaData: {
            requestId: scope.error.data.id,
            requestUrl: scope.error.config.url,
            requestBody: scope.error.originalRequestBody,
            responseCode: scope.error.data.statusCode,
            message: scope.error.data.parameterizedErrorText,
          }
        };

        scope.priority = { listRaw: CONFIG.PRIORITIES, skipOrderByName: true };
        scope.product = { listRaw: CONFIG.PRODUCTS, skipOrderByName: true };
        scope.priorityDefault = getItemById(CONFIG.PRIORITIES, CONFIG.DEFAULT_PRIORITY);
        scope.productDefault = productInfo.product;
        scope.isSingleProduct = productInfo.isSingle;
        scope.singleProductName = productInfo.isSingle ? productInfo.product.name : '';

        scope.helpfullContent = null;

        (function () {
          renderTemplate();
          setPosition();
        })();

        scope.removeAnimate = function () {
          angular.element('.px-new-error-dialog').removeClass('animate');
        };

        scope.addAnimate = function () {
          angular.element('.px-new-error-dialog').addClass('animate');
        };

        function setPosition() {
          $timeout(function () {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();
            var screenVertCenter = $window.innerHeight / 2;
            var menuVerticalCenter = menuHeight / 2;
            var top = screenVertCenter - menuVerticalCenter;
            var screenHorCenter = window.innerWidth / 2;
            var menuHorizontalCenter = menuWidth / 2;
            var left = screenHorCenter - menuHorizontalCenter;
            angular.element('.context-content-container').css({ left: left, top: top });
            angular.element('.context-content-container').css({ display: 'block' });
          }, 50);
        }

        function renderTemplate() {
          var unformatedHelpContent = $filter("translate")(scope.error.linkCaption);
          unformatedHelpContent = unformatedHelpContent.replace(/<\/br\s*[\/]?>/gi, '');
          if (unformatedHelpContent !== scope.error.linkCaption) {
            scope.helpfullContent = unformatedHelpContent;
          }
        }

        scope.rePosition = () => {
          $timeout(() => {
            setPosition();
          }, 150)
        }

        scope.closePopup = function () {
          scope.callback();
        };

        scope.setPriority = function (priority) {
          scope.supportTicket.ticketPriority = priority.id;
        };

        scope.setProduct = function (product) {
          scope.supportTicket.ticketProduct = product.id;
        };

        scope.sendSupportTicket = function (form, $event) {
          if (form && $event) {
            if (form.$invalid) {
              scope.focus = true;
              $event.preventDefault();
            } else {
              var objectToSend = angular.copy(scope.supportTicket);
              objectToSend.ticketProduct = extractId(objectToSend.ticketProduct);
              objectToSend.ticketPriority = extractId(objectToSend.ticketPriority);
              if (!objectToSend.phoneNumber) {
                delete objectToSend.phoneNumber;
              }
              if (objectToSend.email === scope.me.info._embedded.user.email) {
                delete objectToSend.email;
              }
              form.__customProperties.waitingForAnswer = true;
              APIAdmin.addSupportTicket(scope.tenant.info._links["px:csOpenTicket"].href, objectToSend).then(function () {
                form.__customProperties.waitingForAnswer = false;
                form.$setPristine();
                scope.callback();
                toastr.success($filter("translate")("EmailSent"));
              }).catch(function (error) {
                form.__customProperties.waitingForAnswer = false;
              });
            }
          } else {
            throw "scope.sendSupportTicket: form or $event are missing";
          }
        };

        scope.$on('$destroy', function () {
          angular.element('.context-content-container').css({ display: 'none' });
        });

      }
    };
  }

  pxErrorDirective.$inject = [
    '$timeout', '$filter', 'toastr', '$http', '$window', '$rootScope', 'APIAdmin'
  ];

  angular
    .module('printix-admin')
    .directive('pxErrorDirective', pxErrorDirective);

})();
